(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-3-hero"] && !Shopify.designMode) return;
  try {
    
  class ProductFormPdp3 extends HTMLElement {
    constructor() {
      super();
      this.hero = this.closest('.pdp3-hero');
      this.priceEl = this.querySelector('[data-cta-price]');
      this.bigPriceEl = this.hero.querySelector('[data-cta-price-big]');
      this.saveBadgeEl = this.hero.querySelector('[data-savings-badge]');
      this.buyOnceEl = this.querySelector('[data-buyonce-label]');
      this.button = this.querySelector('[data-add-to-cart]');
      this.buyOnceButton = this.querySelector('.pdp3-buyonce');

      this.CHECKOUT_URL = 'https://get.nuflos.com/checkout-3.2-giv';
      this.CAMPAIGN_ID = '2';

      this.addEventListener('change', this.onVariantChange.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.buyOnceButton.addEventListener('click', this.onBuyOnce.bind(this));
    }

    onVariantChange(event) {
      if (event.target.type !== 'radio') return;

      this.querySelectorAll('.pdp3-variant').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(event.target));
      });

      const onetimePriceCents = Number(event.target.getAttribute('data-onetime-price'));
      const subPriceCents = Number(event.target.getAttribute('data-sub-price'));
      const savingsCents = onetimePriceCents - subPriceCents;

      if (this.priceEl) this.priceEl.textContent = this.formatMoney(subPriceCents);
      if (this.bigPriceEl) this.bigPriceEl.textContent = this.formatMoney(subPriceCents);
      if (this.saveBadgeEl) this.saveBadgeEl.textContent = 'Save ' + this.formatMoney(savingsCents);
      if (this.buyOnceEl) this.buyOnceEl.textContent = this.formatMoney(onetimePriceCents);

      this.button.dataset.selectedSubId = event.target.getAttribute('data-sub-id');
      this.buyOnceButton.dataset.buyonceId = event.target.getAttribute('data-onetime-id');
    }

    formatMoney(cents) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }

    buildCheckoutUrl(productId) {
      let url = this.CHECKOUT_URL + '?products=' + encodeURIComponent(productId) + ':1&campaignId=' + this.CAMPAIGN_ID;
      if (window.location.search) {
        const dest = new URL(url);
        new URLSearchParams(window.location.search).forEach((value, key) => {
          dest.searchParams.set(key, value);
        });
        url = dest.toString();
      }
      const dest = new URL(url);
      dest.searchParams.set("cc_custom_landing", decodeURIComponent(window.location.pathname.split("/").pop()));
      url = dest.toString();
      return url;
    }

    onSubmit(event) {
      event.preventDefault();
      window.location.href = this.buildCheckoutUrl(this.button.dataset.selectedSubId);
    }

    onBuyOnce(event) {
      event.preventDefault();
      window.location.href = this.buildCheckoutUrl(this.buyOnceButton.dataset.buyonceId);
    }
  }

  customElements.define('product-form-pdp3', ProductFormPdp3);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.pdp3-hero').forEach((hero) => {
      if (typeof Swiper === 'undefined') return;

      const thumbsSwiper = new Swiper(hero.querySelector('.pdp3-swiper-thumbs'), {
        slidesPerView: 4,
        spaceBetween: 10,
        watchSlidesProgress: true,
        navigation: {
          nextEl: hero.querySelector('.pdp3-swiper-thumbs .swiper-button-next'),
          prevEl: hero.querySelector('.pdp3-swiper-thumbs .swiper-button-prev'),
        },
      });

      new Swiper(hero.querySelector('.pdp3-swiper-main'), {
        spaceBetween: 10,
        thumbs: { swiper: thumbsSwiper },
      });
    });

    document.querySelectorAll('.pdp3-accordion').forEach((accordion) => {
      const rows = accordion.querySelectorAll('.pdp3-accordion__row');
      rows.forEach((row) => {
        row.addEventListener('toggle', () => {
          if (!row.open) return;
          rows.forEach((other) => {
            if (other !== row) other.open = false;
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-3-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pdp3-reviews').forEach((root) => {
    root.querySelectorAll('[data-review-text]').forEach((textEl) => {
      const toggle = textEl.parentElement.querySelector('[data-review-toggle]');
      if (!toggle) return;
      if (textEl.scrollHeight <= textEl.clientHeight + 2) return;
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const expanded = textEl.classList.toggle('is-expanded');
        toggle.textContent = expanded ? 'See less' : 'See more';
      });
    });

    const loadMoreBtn = root.querySelector('[data-load-more]');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        root.querySelectorAll('.pdp3-review.is-extra').forEach((card) => {
          card.hidden = false;
        });
        loadMoreBtn.hidden = true;
      });
    }

    const modal = root.querySelector('[data-review-modal]');
    const modalImage = modal ? modal.querySelector('[data-review-modal-image]') : null;
    const modalClose = modal ? modal.querySelector('[data-review-modal-close]') : null;

    function openModal(src, alt) {
      if (!modal || !modalImage) return;
      modalImage.src = src;
      modalImage.alt = alt || 'Customer photo';
      modal.classList.add('is-open');
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modalImage.src = '';
    }

    root.querySelectorAll('.pdp3-review__image').forEach((img) => {
      img.addEventListener('click', () => openModal(img.src, img.alt));
    });

    if (modalClose) modalClose.addEventListener('click', closeModal);

    if (modal) {
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
